import { logCoreUsage } from 'owa-analytics';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { BizChatSidePaneSources } from 'owa-bizchat-types';
import type { MailboxInfo } from 'owa-client-types';
import {
    getBizChatWindowKey,
    getOrCreateSidePaneOpenToCloseSessionId,
    getTimeSinceSidepaneOpened,
} from 'owa-copilot-chat-drawer-store';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';

/**
 * @param source The entry point source that triggered the BizChat Side Pane opening.
 * @param isFlexPaneAlreadyOpen Indicates whether the BizChat Side Pane is already open,
 *                              used to understand full usage for features that can populate the input box.
 */
export function logBizChatSidePaneEntrypoint(
    source: BizChatSidePaneSources,
    mailboxInfo: MailboxInfo,
    targetWindow: Window,
    isFlexPaneAlreadyOpen?: boolean,
    isNewChat?: boolean
): void {
    if (isGlobalFeatureEnabled('mon-copilot-bizchat')) {
        logCoreUsage('OutlookCopilotChat_BizChatSidePaneEntrypoints', mailboxInfo, {
            source,
            isFlexPaneAlreadyOpen: isFlexPaneAlreadyOpen ?? false,
            isNewChat: isNewChat ?? false,
            isPopout: isPopout(targetWindow),
            windowKey: getBizChatWindowKey(targetWindow),
            sidePaneOpenToCloseSessionId: getOrCreateSidePaneOpenToCloseSessionId(targetWindow),
            timeSinceOpened: getTimeSinceSidepaneOpened(targetWindow),
        });
    }
}
